import { render, staticRenderFns } from "./AddPassengers.vue?vue&type=template&id=cc4bff94&scoped=true&"
import script from "./AddPassengers.vue?vue&type=script&lang=js&"
export * from "./AddPassengers.vue?vue&type=script&lang=js&"
import style0 from "./AddPassengers.vue?vue&type=style&index=0&id=cc4bff94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4bff94",
  null
  
)

export default component.exports